import { Component, OnInit } from '@angular/core';
import { EoptionsService, OptionContract } from 'src/app/services/eoptions.service';
import { ToastrService } from 'ngx-toastr';
import { OptionTradeSocket } from 'src/app/app.module';

@Component({
    selector: 'app-option-order-place',
    templateUrl: './option-order-place.component.html',
    styleUrls: ['./option-order-place.component.css']
})
export class OptionOrderPlaceComponent implements OnInit {
    selectedContract: OptionContract | null = null;
    price: number | undefined;
    amount: string = '';

    constructor(
        private eoptionsService: EoptionsService,
        private toastr: ToastrService,
        private socket: OptionTradeSocket
    ) { }

    ngOnInit(): void {
        this.eoptionsService.selectedContract$.subscribe(contract => {
            if (contract) {
                this.selectedContract = contract;
                console.log("datadata", contract)

                this.price = contract.price;
                this.fetchDepth(); // Fetch depth when contract changes
            }
        });
        this.socket.on('optionDepth', this.depthWS.bind(this))
        this.socket.on('optiontrade', this.tradesWs.bind(this))
    }

    // Order Book Data with Cumulative Sum
    bids: any[] = [];
    asks: any[] = [];
    recentTrades: any[] = [];

    // UI State
    activeTab: 'order' | 'book' | 'trades' = 'order';
    side: 'BUY' | 'SELL' = 'BUY'; // Selected side
    sliderValue: number = 0; // 0-100%
    fetchDepth() {
        if (!this.selectedContract) return;
        this.eoptionsService.getDepth(this.selectedContract.symbol).subscribe({
            next: (res: any) => {
                if (res.status && res.data) {
                    // Process Asks (Sell Orders) - Sort Ascending for rendering
                    let asks = res.data.asks || []; // [price, qty]
                    // Display top 10? Slice first
                    asks = asks.slice(0, 15);
                    let askSum = 0;
                    this.asks = asks.map((a: any) => {
                        askSum += parseFloat(a[1]);
                        return { price: a[0], size: a[1], sum: askSum };
                    });

                    // Process Bids (Buy Orders) - Sort Descending
                    let bids = res.data.bids || [];
                    bids = bids.slice(0, 15);
                    let bidSum = 0;
                    this.bids = bids.map((b: any) => {
                        bidSum += parseFloat(b[1]);
                        return { price: b[0], size: b[1], sum: bidSum };
                    });
                }
            }
        });
    }

    depthWS(data: any) {
        if (!this.selectedContract || !data.symbol || !this.selectedContract.symbol) return;

        if (data.symbol.toLowerCase() == this.selectedContract.symbol.toLowerCase()) {

            if (data.symbol && data.data) {
                // Process Asks (Sell Orders) - Sort Ascending for rendering
                let asks = data.data.a || []; // [price, qty]
                asks = asks.reverse()
                // Display top 10? Slice first
                asks = asks.slice(0, 15);
                let askSum = 0;
                this.asks = asks.map((a: any) => {
                    askSum += parseFloat(a[1]);
                    return { price: a[0], size: a[1], sum: askSum };
                });

                // Process Bids (Buy Orders) - Sort Descending
                let bids = data.data.b || [];
                bids = bids.slice(0, 15);
                let bidSum = 0;
                this.bids = bids.map((b: any) => {
                    bidSum += parseFloat(b[1]);
                    return { price: b[0], size: b[1], sum: bidSum };
                });
            }
        }
    }


    setPrice(price: any) {
        if (price) {
            this.price = parseFloat(price);
            this.setTab('order'); // Switch back to Order Form for convenience
        }
    }

    fetchTrades() {
        if (!this.selectedContract) return;
        this.eoptionsService.getRecentTrades(this.selectedContract.symbol).subscribe({
            next: (res: any) => {
                if (res.status && res.data) {
                    this.recentTrades = res.data || [];
                }
            }
        });
    }
    tradesWs(data: any) {
        if (!this.selectedContract || !data.symbol || !this.selectedContract.symbol) return;

        // if (data.symbol.toLowerCase() == this.selectedContract.symbol.toLowerCase()) {
        // this.recentTrades.push(data.data)
        // }
    }

    setTab(tab: 'order' | 'book' | 'trades') {
        this.activeTab = tab;
        if (tab === 'trades') {
            this.fetchTrades();
        } else if (tab === 'book') {
            this.fetchDepth();
        }
        // 'order' doesn't need specific fetch, maybe refresh balance/contract logic
    }

    setSide(side: 'BUY' | 'SELL') {
        this.side = side;
    }

    // Calculate amount from slider (Mock logic for now)
    onSliderChange(val: any) {
        this.sliderValue = val;
        // logic to set amount based on balance would go here
    }

    get sideLabel(): string {
        return this.selectedContract ? this.selectedContract.type : 'Call';
    }

    placeOrder(side: 'BUY' | 'SELL') {
        if (!this.selectedContract || !this.price || !this.amount) {
            this.toastr.warning('Please fill all fields');
            return;
        }

        const order = {
            symbol: this.selectedContract.symbol,
            side: side,
            type: 'LIMIT',
            quantity: this.amount,
            price: this.price
        };

        // You might want to show loading indicator here
        this.eoptionsService.placeOrder(order).subscribe({
            next: (res) => {
                console.log('Order placed:', res);
                const action = side === 'BUY' ? 'Buy' : 'Sell';
                this.toastr.success(`${action} Order Placed Successfully!`, 'Success');
                this.amount = ''; // clear amount
            },
            error: (err) => {
                console.error('Order failed:', err);
                const msg = err.error?.message || err.message || 'Unknown Error';
                this.toastr.error('Order Failed: ' + msg, 'Error');
            }
        });
    }
}
